export function initProductCardSlider() {
  const sectionEls = document.querySelectorAll(".js-product-card-slider");
  if (!sectionEls.length) return;

  const mobileQuery = window.matchMedia("(max-width: 767px)");
  const viewportHandlers = [];

  sectionEls.forEach((sectionEl) => {
    const sliderEl = sectionEl.querySelector(".product-sectors__slider");
    const btnPrev = sectionEl.querySelector(
      ".product-sectors-slider__nav-btn--prev"
    );
    const btnNext = sectionEl.querySelector(
      ".product-sectors-slider__nav-btn--next"
    );

    if (!sliderEl) return;

    const itemEls = sectionEl.querySelectorAll(".product-sectors__item");
    if (itemEls.length <= 1) return;

    let swiperInstance = null;

    const initSwiper = () => {
      if (swiperInstance) return;

      swiperInstance = new Swiper(sliderEl, {
        slidesPerView: 1.08,
        spaceBetween: 10,
        centeredSlides: true,

        navigation: {
          prevEl: btnPrev,
          nextEl: btnNext,
        },
        loop: true,
        breakpoints: {
          480: {
            slidesPerView: 1.1,
            spaceBetween: 11,
          },
        },
      });
    };

    const destroySwiper = () => {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    const handleViewportChange = () => {
      if (mobileQuery.matches) {
        initSwiper();
      } else {
        destroySwiper();
      }
    };

    viewportHandlers.push(handleViewportChange);
    handleViewportChange();
  });

  const onMediaChange = () => {
    viewportHandlers.forEach((handler) => handler());
  };

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", onMediaChange);
  } else {
    mobileQuery.addListener(onMediaChange);
  }
}
